import {MenuItemProps} from '@dms/api/shared';

export function sortMenuItemsByPosition(items: MenuItemProps[]) {
  const itemsWithPosition: Array<{item: MenuItemProps; position: number}> = [];
  const itemsWithoutPosition: MenuItemProps[] = [];

  items.forEach((item) => {
    const position = item.layoutProps?.position;
    if (typeof position === 'number') {
      itemsWithPosition.push({item, position});
    } else {
      itemsWithoutPosition.push(item);
    }
  });

  itemsWithPosition.sort((a, b) => a.position - b.position);

  if (itemsWithPosition.length === 0) {
    return [...itemsWithoutPosition];
  }

  const result: MenuItemProps[] = [];
  let nonPositionedIndex = 0;
  let currentExpectedPosition = 1;

  for (const {item, position} of itemsWithPosition) {
    while (currentExpectedPosition < position && nonPositionedIndex < itemsWithoutPosition.length) {
      result.push(itemsWithoutPosition[nonPositionedIndex]);
      nonPositionedIndex++;
      currentExpectedPosition++;
    }

    result.push(item);
    currentExpectedPosition = Math.max(currentExpectedPosition, position) + 1;
  }

  while (nonPositionedIndex < itemsWithoutPosition.length) {
    result.push(itemsWithoutPosition[nonPositionedIndex]);
    nonPositionedIndex++;
  }

  return result;
}
